const CHUNK_RELOAD_KEY = 'pro-studio:chunk-reload-at';
// If a reload triggered by a chunk error is itself followed by another chunk
// error inside this window, we stop reloading and let the error surface —
// otherwise a genuinely-missing asset would reload-loop forever.
const CHUNK_RELOAD_WINDOW_MS = 10_000;

/**
 * Reload once to recover from a stale chunk after a deploy. Returns `true` if a
 * reload was triggered (caller should stop handling the error), or `false` if a
 * recent reload already failed — in which case the caller should surface the
 * error instead of looping.
 *
 * Stays in Pro Studio rather than moving to the shared boundary: auto-reloading
 * is a product decision this app has made and Manager has not.
 */
export const reloadOnceForChunkError = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const last = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);

    if (last && Date.now() - last < CHUNK_RELOAD_WINDOW_MS) {
      // We already reloaded for a chunk error moments ago and it still failed —
      // don't loop. Clear the marker so a future, unrelated failure can retry.
      window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);

      return false;
    }

    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    // sessionStorage unavailable (private mode / quota) — reload once anyway.
  }

  window.location.reload();

  return true;
};
